import { render, staticRenderFns } from "./reviews-branch.vue?vue&type=template&id=77cc2481"
import script from "./reviews-branch.vue?vue&type=script&lang=js"
export * from "./reviews-branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports